import {InvoiceDao} from '../../dao';
import {ErrorModel, InvoiceModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_INVOICE_BY_ID';

export async function getInvoiceById(userData: Record<string, string>, id: number) {
    try {
        const invoice = await InvoiceDao.getInvoiceById(userData.userToken, id);

        const invoiceParsed = InvoiceModel.parseInvoice(invoice);

        return invoiceParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
